import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deactivated: {
		id: 'project-components.lead.deactivated-status',
		defaultMessage: '{userName} <status>(Deactivated)</status>',
		description:
			'Text displayed to the right of the user name of a deactivated user in user picker field',
	},
});
